import { parseHtml } from '@healthhub/react-ui';
import { Typography } from 'antd';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

import { RetrieveDataError, RetrieveDataErrorMobile } from '@shared/assets';
import { Button } from '@shared/components/Button';
import { useLayoutViewContext } from '@shared/context';

import type { IRetrieveDataErrorDisplayProps } from './RetrieveDataErrorDisplay.types';

const { Link, Text } = Typography;

const RetrieveDataErrorDisplay = ({
  errorCode,
  errorImg,
  errorMsg,
  refreshButtonText,
  hideContact,
  hideRefresh,
  hideTitle,
  onRefresh,
  stack,
  isLoading,
  title,
}: IRetrieveDataErrorDisplayProps) => {
  const { isMobileView } = useLayoutViewContext();

  const { t } = useTranslation();

  const renderErrorMessage = () => {
    if (!errorMsg) {
      return <p className="m-0">{t('dataErrorDisplay.tryLater')}</p>;
    }

    if (typeof errorMsg === 'string') {
      return <p className="m-0">{parseHtml(DOMPurify.sanitize(errorMsg))}</p>;
    }

    return errorMsg;
  };

  const errorImage = errorImg ?? (isMobileView ? RetrieveDataErrorMobile : RetrieveDataError);
  const displayTitle = title ?? t('dataErrorDisplay.title');

  return (
    <div className="flex flex-col items-center gap-y-5 p-12">
      <img alt="" data-testid="retrieve-data-error-image" src={errorImage} />
      {!hideTitle && <p className="m-0 text-center text-lg font-semibold">{displayTitle}</p>}
      <div className="flex flex-col items-center gap-y-5">
        {renderErrorMessage()}
        {!hideContact && (
          <Text className="text-sm text-center">
            {t('emptyState.contactUs')}&nbsp;
            <Link className="font-semibold text-theme-600" href="mailto:contact_us@healthhub.sg">
              contact_us@healthhub.sg.
            </Link>
          </Text>
        )}

        {!!(errorCode || stack) && (
          <p className="m-0 inline-block text-base text-functional-black">(Code: {errorCode || stack})</p>
        )}
      </div>
      {!hideRefresh && (
        <Button className="w-full" loading={isLoading} onClick={onRefresh}>
          {refreshButtonText ?? t('dataErrorDisplay.refreshBtn')}
        </Button>
      )}
    </div>
  );
};
export default RetrieveDataErrorDisplay;
